module.exports = __webpack_public_path__ + "img/Warrior-draenei-f-70.78fb72ad.gif";